import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { Popover } from '@material-ui/core';

export const DatePickerContainer = styled.div`
    height: auto;

    .p-component {
        font-family: AvenirNextWorld Regular;
        color: #3c3c3c;
    }
    .p-dropdown-items-wrapper {
        max-height: 210px !important;
    }
    .p-dropdown-panel .p-dropdown-items {
        padding: 0.2rem 0 0.5rem 0;
    }
    .p-dropdown-panel {
        min-width: max-content !important;
    }
    .p-dropdown-panel .p-dropdown-item {
        white-space: nowrap;
        overflow: visible;
        text-overflow: unset;
    }
    .p-datepicker {
        border: 0px;
    }

    .p-datepicker-group-container {
        max-width: 270px;
    }

    span#undefined.p-calendar {
        width: 100%;
        margin-left: -3px;
    }
    span > button {
        visibility: hidden;
    }
    .p-datepicker-title {
        display: flex;
    }
    .p-dropdown {
        border: 0px !important;
    }
    .p-dropdown:not(.p-disabled).p-focus {
        box-shadow: none !important;
    }
    .p-datepicker td > span {
        margin-right: 2px;
        margin-left: 2px;
        @media screen and (min-device-width: 319px) and (max-device-width: 360px) {
            width: 2.1rem;
        }
    }

    .p-datepicker-header {
        padding: 0 10px 0 5px;
        border-bottom: 0px;
        @media screen and (min-device-width: 319px) and (max-device-width: 360px) {
            padding: 0 35px 0 5px;
        }
    }

    .p-datepicker table td {
        padding: 0px;
        height: 30px;
        width: 30px;
    }
    .p-dropdown-label.p-inputtext {
        font-family: AvenirNextWorld Bold;
        font-size: 17px;
        padding-right: 0px;
    }

    .pi {
        font-size: 12px;
        padding-bottom: 2px;
    }

    .p-datepicker-next .p-link {
        border: 0px;
    }
    .p-datepicker-prev,
    .p-datepicker-next:focus {
        box-shadow: none !important;
    }

    .p-datepicker-prev {
        pointer-events: ${(props) => (props.disableLeftArrow ? 'none' : '')};
        opacity: ${(props) => (props.disableLeftArrow ? 0.2 : 1)};
    }

    .p-datepicker-prev-icon.pi.pi-chevron-left {
        content: url(${(props) => props.leftArrow});
    }

    .p-datepicker-next-icon.pi.pi-chevron-right {
        content: url(${(props) => props.rightArrow});
    }

    .p-datepicker table td span.p-highlight {
        background-color: unset !important;
        border: 1px solid #f26522;
    }

    .p-dropdown-trigger-icon.pi.pi-chevron-down {
        content: url(${(props) => props.downArrowMonthDropDown});
    }
    .p-datepicker table td.p-datepicker-today > span {
        font-family: AvenirNextWorld Bold;
        background-color: unset !important;
        color: #3c3c3c;
        opacity: 1;
    }
`;

export const DatePickerDiv = styled.div`
    position: relative;
    border: ${(props) => (props.border ? props.border : '1px solid #4f4f4f59')};
    cursor: ${(props) => !props.disabled && 'pointer'};
    border-radius: ${(borderRadius) => (borderRadius ? borderRadius : '4px')};
    display: flex;
    align-items: center;
    width: ${(props) => (props.width ? props.width : '10vw')};
    height: ${(props) => (props.height ? props.height : '7vh')};
    justify-content: space-around;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    font-family: 'AvenirNextWorld Regular';
    opacity: ${(props) => (props.opacity ? props.opacity : '1')};
    color: #202124;
    min-width: ${(props) => (props.minWidth ? props.minWidth : '')};

    &[aria-describedby='simple-popover'] {
        background-color: ${({ backgroundColor }) =>
            backgroundColor ? backgroundColor : '#ffebbf4d;'};
    }
    background-color: ${({ reportUsage, backgroundColor }) =>
        reportUsage && backgroundColor};

    ${media.mobileDevice`
        width: ${(props) => (props.mbWidth ? props.mbWidth : '40vw')};
        height: ${(props) => (props.mbHeight ? props.mbHeight : '6vh')};
        background-color: ${({ backgroundColor }) =>
            backgroundColor ? backgroundColor : '#ffebbf4d;'};
    `};
    @media only screen and (max-device-width: 360px) {
        width: ${(props) => (props.smbWidth ? props.smbWidth : 'auto')};
    }
    @media only screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait) {
        width: ${(props) => (props.sameDayRdd ? '150px' : props.width)};
    }

    &:hover { 
        border: 1px solid #000000 !important;
    }
`;

export const DatePickerIcon = styled.img.attrs((props) => ({
    src: props.defaultImg,
    alt: props.name,
    height: props.height,
}))`
    height: ${({ height }) => (height ? height : '23px')};
    ${media.mobileDevice`
        height: ${({ height }) => (height ? height : '23px')};
    `}
    @media only screen and 
    (max-device-width: 360px) {
        display: flex;
        align-self: center;
        height: ${({ smbIconheight }) =>
            smbIconheight ? smbIconheight : '20px'};
    }
`;

export const StyledClearSpan = styled.span`
    position: absolute;
    right: 0.8rem;
    color: #1010eb;
    font-family: AvenirNextWorld Demi;
    font-size: 13px;
    cursor: pointer;
    @media screen and (min-device-width: 319px) and (max-device-width: 360px) {
        right: 0.4rem;
    }
`;

export const StyledDiv = styled.div`
    position: absolute;
    left: ${({ left }) => (left ? left : '15px')};
    opacity: ${({ opacity, reportUsage, textOpacity }) =>
        reportUsage && textOpacity ? textOpacity : opacity ? opacity : 1};
    color: ${({ placeholderColor }) =>
        placeholderColor ? placeholderColor : ''};
    @media only screen and (max-device-width: 360px) {
        left: 4px;
    }
`;
export const StyledSpan = styled.div`
    padding-top: ${({ iconPaddingTop }) =>
        iconPaddingTop ? iconPaddingTop : '5px'};
    position: absolute;
    right: ${({ iconRight }) => (iconRight ? iconRight : '10px')};
    @media only screen and (max-device-width: 360px) {
        padding-top: ${({ smbIconPaddingTop }) => smbIconPaddingTop};
        right: 2px;
    }
    @media only screen and (min-width: 360px) and (max-width: 500px) {
        right: ${({ mbIconRight }) => (mbIconRight ? mbIconRight : '')};
    }
`;
export const DatePopover = styled(Popover)`
    & .MuiPaper-root {
        top: ${({ top }) => (top > 400 ? top - 320 + 'px !important' : '')};
        ${media.mobileDevice`
            transition: all 50ms ease-in-out !important;
        `};
    }
`;
